import { call, put, takeEvery } from "redux-saga/effects";

import { API } from "../../../beans";
import { patch } from "../../../utils/requestV3MyzToken";

import {
  IConfirmRequest,
  ConfirmAction,
  ConfirmActionEnum,
  confirmFail,
  confirmSuccess,
} from "./actions";

export function* confirmRequestSaga(action: IConfirmRequest) {
  const requestURL = `/wotd/subscriptions/${action.hash}/${action.confirmCode}`;
  const requestOpt = {
    // 'X-Auth-Token': action.token,
  };

  try {
    const { data } = yield call(patch, requestURL, requestOpt);
    yield put(confirmSuccess(data));
  } catch (err) {
    yield put(confirmFail(err));
  }
}

export function* sagas() {
  yield takeEvery(ConfirmActionEnum.REQUEST, confirmRequestSaga);
}

export interface IConfirmState {
  loading: boolean;
  loaded: null | boolean;
  data: null | API.Confirm;
  error: null | Error;
}

const initialState: IConfirmState = {
  loading: false,
  loaded: null,
  data: null,
  error: null,
};

const Confirm = (
  state: IConfirmState = initialState,
  action: ConfirmAction,
): IConfirmState => {
  switch (action.type) {
    case ConfirmActionEnum.REQUEST:
      return {
        ...state,
        loading: true,
      };
    case ConfirmActionEnum.SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        data: action.data ? { ...action.data } : null,
      };
    case ConfirmActionEnum.FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.err,
      };
    default:
      return state;
  }
};
export default Confirm;
